import { useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import "./BudgetTracker.css";

//This section of code refers to the categories of expenses and the ability to delete and add them on to a list
//The AddExpense function is the top level function that contains the states
function AddExpense(props) {
  const [newExpense, setNewExpense] = useState("");
  const param = useParams();

  //This function will allow the user to change the field value due to the function returns event.target.value, which is the new inputted value
  function handleInputChange(event) {
    setNewExpense(event.target.value);
  }

  //This function will link the budget inputted for each expense to its expense name within the object
  async function handleBudgetChange(index, event) {
    const value = isNaN(parseFloat(event.target.value))
      ? 0
      : parseFloat(event.target.value);

    const updatedExpenses = props.expenses.map((item, i) =>
      i === index ? { ...item, budget: value } : item
    );

    props.setExpenses(updatedExpenses);

    // Want to leave this code in for future reference.
    // Automatically save when budget is changed
    // try {
    //   await axios.post("http://localhost:5000/budget-saved", {
    //     expense_name: updatedExpenses[index].name,
    //     category: props.heading,
    //     amount: value,
    //     currency: "GBP",
    //     date: new Date().toISOString().split("T")[0],
    //     trip_id: param.trip_id,
    //   });
    // } catch (error) {
    //   console.error("Failed to save budget update:", error);
    // }
  }

  //function created to connect to the backend to send input information to SQL table
  const handleSaveExpense = async (index) => {
    try {
      await axios.post("http://localhost:5000/budget-saved", {
        expense_name: props.expenses[index].name,
        category: props.heading,
        amount: props.expenses[index].budget,
        currency: "GBP",
        date: new Date().toISOString().split("T")[0],
        trip_id: param.trip_id,
      });
    } catch (error) {
      console.error("Failed to save expense:", error);
    }
  };

  //This function will add a new expense, with an object expense name and its budget
  //A callback function 'previous =>' will add the new expense to the existing list of expenses
  async function addNewExpense() {
    if (newExpense.trim() !== "") {
      const newItem = { name: newExpense, budget: 0 };

      const updatedExpenses = [...props.expenses, newItem];
      props.setExpenses(updatedExpenses);
      setNewExpense("");

      // Want to leave this code in for future reference.
      // Immediately save to backend
      // try {
      //   await axios.post("http://localhost:5000/budget-saved", {
      //     expense_name: newItem.name,
      //     category: props.heading,
      //     amount: newItem.budget,
      //     currency: "GBP",
      //     date: new Date().toISOString().split("T")[0],
      //     trip_id: param.trip_id,
      //   });
      // } catch (error) {
      //   console.error("Failed to save new expense:", error);
      // }
    }
  }

  function deleteExpense(index) {
    const updatedExpenses = props.expenses.filter((_, i) => i !== index);
    props.setExpenses(updatedExpenses);
    // Optional: DELETE request to backend - would have done this if there was more time.
  }

  return (
    <>
      <p className="expense-heading">{props.heading}</p>

      <div className="expense">
        <input
          className="expense-input"
          type="text"
          placeholder="Enter an Expense Name..."
          value={newExpense}
          onChange={handleInputChange}
          onKeyDown={(e) => {
            if (e.key === "Enter") addNewExpense();
          }}
        />

        <button className="add-expense-button" onClick={addNewExpense}>
          Add
        </button>
      </div>

      <ol className="expense-order-list">
        {props.expenses.map((expense, index) => (
          <li className="expense-list" key={index}>
            <p className="text">{expense.name}</p>
            <span className="currency">£</span>
            <input
              className="expense-budget-input"
              type="number"
              min="0"
              step="0.01"
              placeholder="input budget"
              value={expense.budget}
              onChange={(e) => handleBudgetChange(index, e)}
            />

            <button
              className="delete-button"
              onClick={() => deleteExpense(index)}
            >
              Delete
            </button>

            <button
              className="add-expense-button"
              onClick={() => handleSaveExpense(index)}
            >
              Save
            </button>
          </li>
        ))}
      </ol>
    </>
  );
}

export default AddExpense;
